export function beforeSend(event) {
  const fetchError = event.exception.values.filter((e) => e.type == 'FetchError')
  if (fetchError.length) {
    const status = parseInt(fetchError[0].value.match(/: (\d{3})/)?.[1]) || null
    if (status < 500) {
      return null
    }
  }

  return event
}